export default __webpack_public_path__ + "static/media/logo-small.81119cfb.svg";